<template>
  <div class="prescription">
    <div class="header-tab">
      <el-card
        class="prescription_title_card"
        shadow="hover"
        v-for="(item, index) in tabList"
        :key="item.index"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.introduce"
          placement="bottom"
        >
          <div class="prescription_title_content">
            <div class="prescription_title_img">
              <img :src="item.icon" alt />
            </div>
            <div class="text">
              <el-tag class="title" :type="setType(index)">{{
                item.title
              }}</el-tag>
              <p class="num">{{ item.number || 0 }}</p>
            </div>
          </div>
        </el-tooltip>
      </el-card>
    </div>
    <div class="bd">
      <div slot="header" class="header">
        <div class="searchList">
          <el-select v-model="status" placeholder="请选择" @change="optChange">
            <el-option
              v-for="(item, key) in PRESCRIPTION_STATUS"
              :key="key"
              :label="item"
              :value="key"
            ></el-option>
          </el-select>
        </div>
        <div class="block searchTime">
          <el-date-picker
            v-model="time"
            type="daterange"
            align="center"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="timeChange"
          ></el-date-picker>
        </div>
        <el-button
          type="text"
          style="margin-left: 30px; margin-bottom: 70px"
          @click="empty"
          >清空条件</el-button
        >
      </div>
      <div class="text list-bd" style="min-height: 300px; margin-top: 20px">
        <div v-if="listData.length != 0" class="listWarpper">
          <el-card shadow="hover" v-for="item in listData" :key="item.id">
            <div class="content">
              <div class="c_img">
                <img :src="item.patient.memberAvatar || defalutAvatar" alt />
              </div>
              <div class="content-right">
                <div class="text centerBox">
                  <p>姓名：{{ item.patient.patientName }}</p>
                  <p>年龄：{{ item.patient.patientAge }}</p>
                  <!-- <p>科室：{{ item.department_name }}</p> -->
                  <p>
                    进度状态：
                    <!-- 状态 
                      0未审核 
                      3 一级药师审核驳回 
                      5 一级药师未签字(通过处方)
                      6一级药师已审核(复核药师待审核)
                      7 复核药师未签字(驳回处方)
                      8 复核药师驳回
                      9 复核药师未签字
                      10 复核药师审核通过【报告待生成】
                      100报告生成-->
                    <!-- 已出报告  -->
                    <el-tag
                      :type="
                        item.recipe.status === 11810
                          ? 'success'
                          : item.recipe.status === 11811
                          ? 'info'
                          : item.recipe.status >= 11800 &&
                            item.recipe.status < 11808
                          ? 'danger'
                          : ''
                      "
                      effect="plain"
                      >{{ PRESCRIPTION_STATUS[item.recipe.status] }}</el-tag
                    >
                  </p>
                </div>
                <div class="text right_box">
                  <!-- 签名 0待签名 1已签名 2签名失败 -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="该处方尚未签名,点击即可发起签名"
                    placement="top"
                  >
                    <el-button
                      v-if="item.recipe.status == 11801"
                      type="primary"
                      class="signature"
                      @click="signature(item.recipe)"
                      >签名
                    </el-button>
                  </el-tooltip>
                  <!-- <p class="c_btn" v-if="userType == 2 && item.status == 10" @click="getPdf(item)">
                      生成报告
                    </p> -->
                  <p class="c_btn" @click="reportDetail(item.recipe)">
                    查看详情
                  </p>
                  <p class="c_time">{{ item.recipe.startDate }}</p>
                </div>
              </div>
            </div>
          </el-card>
          <div class="page">
            <el-pagination
              v-if="listData != ''"
              @current-change="currentPageChange"
              :page-size="pageList.size"
              :current-page="pageList.current"
              layout="total, prev, pager, next"
              :total="pageList.total"
            ></el-pagination>
          </div>
        </div>
        <div v-else class="empty">
          <emptyData />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRecipeCount } from '@/api';
import {
  getPrescriptionList,
  prescriptionSign,
  setSuperviseCityPdf,
} from '@/api/doctor';
import pdf from 'vue-pdf';
import config from '@/config/config.js';
import emptyData from '@/components/common/emptyData.vue';
import { PRESCRIPTION_STATUS } from '@/utils/constants';

export default {
  name: 'prescription',
  components: { pdf, emptyData },
  props: {},
  data() {
    return {
      PRESCRIPTION_STATUS,
      // userType: util.getStore("userType"),
      pageSize: 5,
      pageNo: 1,
      user: {},
      listData: [],
      pageList: {},
      defalutAvatar: config.defaultUserPatientsIcon,
      isPdfShow: false,
      pdfUrl: '',
      tabName: '',
      options: [
        {
          status: '',
          label: '全部',
        },
        {
          status: '2',
          label: '一级药师待审核',
        },
        {
          status: '3',
          label: '一级药师审核驳回',
        },
        {
          status: '6',
          label: '复核药师待审核【一级药师已审核】',
        },

        {
          status: '8',
          label: '复核药师驳回',
        },
        {
          status: '10',
          label: '审核通过【报告待生成】',
        },
        {
          status: '100',
          label: '报告生成',
        },
      ],
      status: '',
      time: [],
      tabList: [
        {
          icon: require('../../../assets/images/prescription1.png'),
          title: '合计处方',
          introduce: '当前所有已经审核过的处方',
          number: '',
        },
        {
          icon: require('../../../assets/images/prescription2.png'),
          title: '待签处方',
          introduce: '当前审核通过或者拒绝的处方待签字合计',
          number: '',
        },
        {
          icon: require('../../../assets/images/prescription2.png'),
          title: '审核中',
          introduce: '当前用户已经提交并且在审核中的处方合计',
          number: '',
        },
        {
          icon: require('../../../assets/images/prescription3.png'),
          title: '不合格处方',
          introduce: '当前已经提交并且拒绝的处方',
          number: '',
        },
        {
          icon: require('../../../assets/images/prescription4.png'),
          title: '合格处方',
          introduce: '截止此时已经审核通过的处方',
          number: '',
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      value1: '',
      value2: '',
    };
  },
  created() {
    this.getPrescriptionList();
    this.getRecipeCount();
  },
  mounted() {
    this.status = this.$route.query.status || '';
    // this.getReportList();
    // this.indexPrescriptionTotal();
  },
  methods: {
    // 处方列表统计接口
    async getRecipeCount() {
      const res = await getRecipeCount();
      if (res.code == 1) {
        this.tabList[0].number = res.data.combinedPrecription;
        this.tabList[1].number = res.data.issuingPrecription;
        this.tabList[2].number = res.data.inTheReview;
        this.tabList[3].number = res.data.unqualified;
        this.tabList[4].number = res.data.qualified;
      }
    },
    // 处方列表
    async getPrescriptionList() {
      const params = {
        status: this.status,
        startDate: this.time[0] ? this.time[0] : '',
        endDate: this.time[1] ? this.time[1] : '',
        currentPage: this.pageNo,
        pageSize: this.pageSize,
      };
      const res = await getPrescriptionList(params);
      if (res.code == 1) {
        this.listData = res.data.dataList;
        this.pageList.size = Number(res.data.size);
        this.pageList.current = Number(res.data.currentPage);
        this.pageList.total = Number(res.data.totalCount);
      }
    },
    // 下一页
    currentPageChange(val) {
      this.pageNo = val;
      this.getPrescriptionList();
    },
    // 状态搜索
    optChange() {
      this.getPrescriptionList();
    },
    // 时间搜索
    timeChange() {
      this.getPrescriptionList();
    },
    // 清空
    empty() {
      this.status = '';
      this.pageNo = 1;
      this.time = [];
      this.getPrescriptionList();
    },

    //标签类型设置
    setType(index) {
      switch (index) {
        case 0:
          return 'primary';
          break;
        case 1:
          return 'danger';
          break;
        case 2:
          return 'warning';
          break;
        case 3:
          return 'success';
          break;
      }
    },
    async indexPrescriptionTotal() {
      try {
        const params = {};
        let res = await prescriptionTotal(params);
        if (res.success) {
          // totalPR);//合计处方
          // totalWaitAuditDoing);//审核中处方
          // totalWaitAudit);//待审核处方
          // unQualified);//不合格处方
          // totalWaitSign);//待签处方
          // qualified);//合格处方
          this.tabList[0].number = res.result.totalPR;
          this.tabList[1].number = res.result.totalWaitSign;
          this.tabList[2].number = res.result.totalWaitAuditDoing;
          this.tabList[3].number = res.result.unQualified;
          this.tabList[4].number = res.result.qualified;
        }
      } catch (error) {}
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = '';
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /*
     *签名
     */
    async signature(item) {
      const params = {
        recipeId: item.id,
      };
      const res = await prescriptionSign(params);
      if (res.code == 1) {
        // this.$message.success("已提交签名任务至信手书，请在信手书完成下一步签名操作");
        window.location.href = res.data;
        // 同步数据到传监管平台
        await setSuperviseCityPdf({
          orderNo: item.orderNo,
        });
        this.getPrescriptionList();
      }

      // try {
      //   console.log(item, "item");
      //   let data = {
      //     prescriptionId: item.id,
      //   };
      //   let res = await prescription(data);
      //   if (res.success) {
      //     this.elementTips("success", res.message);
      //     this.getReportList();
      //   } else {
      //     this.elementTips("warning", res.message);
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
    },
    /**
     * 选择状态
     */
    // optChange() {
    //   console.log("status", this.status);
    //   this.getReportList();
    // },
    //时间搜索
    // timeChange() {
    //   console.log("tiem", this.time);
    //   this.getReportList();
    // },
    // currentPageChange(val) {
    //   var that = this;
    //   that.pageNo = val;
    //   that.getReportList();
    // },
    /**
     * 点击预览详情
     */
    reportDetail(item) {
      let query = {
        prescriptionId: item.id,
        orderNo: item.orderNo,
      };
      this.$router.push({
        path: '/index/work/prescriptionDetail',
        query,
      });
    },
    async getReportList() {
      try {
        const that = this;
        let data = {
          // status: that.status == "-1" ? "" : that.status,
          status: that.status,
          // startTime: that.time.length > 0 ? that.time[0].getTime() : "",
          // endTime: that.time.length > 0 ? that.time[1].getTime() : "",
          startTime: that.time[0],
          endTime: that.time[1],
          pageNo: that.pageNo,
          pageSize: that.pageSize,
        };
        let res = await getPrescription(data);
        if (res.success) {
          this.listData = res.result.dataList;
          this.pageList = res.result;
        }
      } catch (error) {}
    },
    handleClose(done) {
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.nodata {
  position: relative;
  // bottom: 90px;
}

.el-button--text {
  color: #fc701a;
}
.prescription {
  // width: 100%;
  margin: 20px 10px 10px 10px;
  .listWarpper {
    width: 100%;
  }
}
.header {
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  left: 20px;
}
.searchTime {
  margin-left: 30px;
}
.content {
  display: flex;
  padding: 20px;
  .c_img {
    width: 100px;
    height: 100px;
    text-align: center;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100px;
    }
  }
  .content-right {
    flex: 1;
    display: flex;
    .text {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .signature {
      align-content: center;
      width: 80px;
      margin: 0 auto;
    }
    .centerBox {
      flex: 0 0 65%;
      margin-left: 15px;
    }
    .right_box {
      flex: 0 0 25%;
      text-align: center;
      .c_btn {
        // color: #409eff;
        color: #fc701a;
        cursor: pointer;
      }
      .c_time {
        color: rgb(167, 157, 157);
      }
    }
  }
}
.header-tab {
  display: flex;
  justify-content: space-around;
  .prescription_title_card {
    width: 200px;
    text-align: center;
  }
}
.list-bd {
  display: flex;
}
.bd {
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .page {
    text-align: center;
  }
}

.pdf span {
  display: block !important;
}
.prescription_card {
  //   height: 130px;
  margin-top: 20px;
}
.prescription_card_p_title {
  font-weight: 700;
  margin-bottom: 10px;
}

.prescription_title_card {
  background-color: #f6f7fb;
}
.prescription_title_content {
  padding: 15px 0 0 0;
  .text {
    .title {
      font-size: 22px;
      margin-top: 10px;
    }
    .num {
      font-size: 18px;
      margin-top: 10px;
      color: rgba(000, 00, 0, 0.8);
    }
  }
}

.prescription_title_img img {
  width: 60px;
}
.prescription .empty {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  margin-top: 10%;
}
.prescription .right_box .el-tag {
  margin: 0 auto;
  width: 30%;
}
</style>
